import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { IntervalPrice, RentalObjectInfo } from 't4core';
import { ComponentBase } from 't4core';


@Component({
    selector: 't4-objectInfo',
    templateUrl: './objectInfo.component.html',
    styleUrls: ['./objectInfo.component.css'],
})
export class ObjectInfoComponent extends ComponentBase implements OnInit {
    @Input() public objectId: number;
    @Input() public object: RentalObjectInfo = new RentalObjectInfo();

    public _prices: IntervalPrice[] = [];

    public cache = [];

    constructor() {
        super();
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.object && !this.objectId) return;

      if (changes.object && changes.object.currentValue) {
        this.objectId = this.object.Id;
            this.loadData();
        } else if(changes.objectId && changes.objectId.currentValue != 0) {
            this.loadData(true);
        }
    }

  private async loadData(loadObject: boolean = false) {
        var id = this.objectId;
    var cached = this.cache.find(x => x.Id == id);
        if (cached) {
            this.object = cached.Object;
            this._prices = cached.Prices.sort((a, b) => b.Period - a.Period);
            return;
        }

    var obj = null;
    var prices: IntervalPrice[] = null;
        if (loadObject) {
          obj = await this.Api.get<RentalObjectInfo>("RentalObject/GetObjectInfo", { objectId: id });
          console.log("object info", obj);
    }
    if (obj == null) return;

    prices = await this.Api.get<IntervalPrice[]>("Price/GetPriceOverview", { typeId: obj.Type.Id });

    if (this.objectId == id) {
      this.object = obj;
      this._prices = prices.sort((a, b) => { return a.Period < b.Period ? -1 : 1; });
    }

        this.cache.push({
            Id: id,
            Object: obj,
          Prices: prices.sort((a, b) => { return a.Period < b.Period ? -1 : 1; })
        });
    }
}
